import { render, staticRenderFns } from "./feedback-buttons.vue?vue&type=template&id=69396434&scoped=true&"
import script from "./feedback-buttons.vue?vue&type=script&lang=js&"
export * from "./feedback-buttons.vue?vue&type=script&lang=js&"
import style0 from "./feedback-buttons.vue?vue&type=style&index=0&id=69396434&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69396434",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69396434')) {
      api.createRecord('69396434', component.options)
    } else {
      api.reload('69396434', component.options)
    }
    module.hot.accept("./feedback-buttons.vue?vue&type=template&id=69396434&scoped=true&", function () {
      api.rerender('69396434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/feedback-buttons/feedback-buttons.vue"
export default component.exports